const Centered = ({children}) => (
    <div className="centered">
        {children}
    </div>
)

export default Centered;